import { waitForAsync } from '@angular/core/testing';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RestApi } from "src/app/shared/RestApi/restApi";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { Router } from '@angular/router';


interface dnsResponse{
  message : string
  error : boolean
  statusMessage: string
}
@Injectable({
  providedIn: 'root'
})
export class VaultdnsAccessService {

  private  headers= new HttpHeaders({
    'Content-Type':'application/json'
  });


  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,
    private restAPI: RestApi,
    private router: Router
  ) { }

    async retrieveDnsName( fieldValue) {

      this.spinner.start();
  
      let response = await this.http.get<dnsResponse>(this.restAPI.VAULT_DNS_ACCESS_DATA + "/" + fieldValue, { headers: this.headers }).toPromise();
  
      console.log(response)
      
      if (response.error == true) {
  
        this.spinner.stop();
  
        this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });
  
        return null;
  
      }
      else {
  
        this.spinner.stop();
  
        return response;
  
      }
  
    }
     insertDNSData(dnsData){
       console.log (dnsData);
       console.log("inside insert dns data")
      return this.http.post<dnsResponse>(this.restAPI.VAULT_DNS_INSERT_DATA,JSON.stringify(dnsData),  { headers: this.headers });
  
    }
  }

  


  // insertobjectgroup(reportCreationData){
  //   console.log(reportCreationData);
  //   return this.http.post<toolResponse>(this.restAPI.INSERT_OBJECTGROUP,JSON.stringify(reportCreationData),{headers:this.headers})
  // }
  // retrieveobjectgroup(){
  //   return this.http.get<objectGroup[]>(this.restAPI.RETRIEVE_OBJECTGROUP,{headers:this.headers})
  // }

